import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Trans } from 'react-i18next'
import { MaluLogoImage, MaluLogoLink, RightContentWrapper, TextCopyright, TextCopyrightLink } from './FooterRightContent.styled'
import maluLogo from '../../../assets/images/malu-white.png'
import { FooterSeparator } from '../Footer.styled'

const FooterRightContent: React.FC = () => {
  const theme = useTheme()

  if (theme.palette.branding.hideMaluBranding) {
    return null
  }

  return (
    <RightContentWrapper>
      <MaluLogoLink href="https://malu.gr" target="_blank" rel="noopener noreferrer" aria-label="Malu">
        <MaluLogoImage alt="malu Logo" src={maluLogo} />
      </MaluLogoLink>
      <TextCopyright sx={{ whiteSpace: 'pre-wrap' }}>
        <Trans
          i18nKey="footer.copyright"
          shouldUnescape={true}
          components={{
            belma: (
              <>
                <TextCopyrightLink href="https://belma.gr" target="_blank" rel="noopener noreferrer">
                  Belma
                </TextCopyrightLink>
                &nbsp;
                <FooterSeparator orientation="vertical" component="span" flexItem />
              </>
            ),
          }}
        />
      </TextCopyright>
    </RightContentWrapper>
  )
}

export default FooterRightContent
